import React from "react";
import "./volunteerInfoBox.scss";

import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

import { Dropdown } from "react-bootstrap";

import { isEmpty } from "../../utils/validation.js";
import {
  changePermissionWS,
  removeVolunteerWS,
} from "./api/volunteerInfoBoxApi.js";
import { gestioneSnackbar } from "../../utils/common.js";
import { t } from "i18next";

const VolunteerInfoBox = ({
  image,
  name,
  phone,
  id,
  email,
  request = false,
  idAssociation,
  admin,
  refreshContent,
  acceptCallback,
  rejectCallback,
}) => {
  return (
    <div className="volunteer-info-box-container">
      <div className="volunteer-info-box-wrapper">
        <div className="left-column">
          <img src={image} />
        </div>
        <div className="right-column">
          <div className="info-volunteer">
            <PersonOutlinedIcon className="icon-info-box" />
            <span className="info-text">{name}</span>
          </div>
          <div className="info-volunteer">
            <LocalPhoneOutlinedIcon className="icon-info-box" />
            <span className="info-text">{phone}</span>
          </div>
          <div className="info-volunteer">
            <MarkunreadOutlinedIcon className="icon-info-box" />
            <span className="info-text">{email}</span>
          </div>
        </div>
      </div>
      {!request ? (
        <div className="menu-icon">
          <Dropdown>
            <Dropdown.Toggle
              as="button"
              variant="light"
              id="dropdown-menu"
              className=" bg-transparent border-0 p-0"
            >
              <MoreVertOutlinedIcon style={{ color: "#000" }} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={(e) => {
                  e.preventDefault();
                  changePermissionWS({
                    id_user_association: id,
                    id_association: idAssociation,
                    admin: admin ? false : true,
                  })
                    .then((res) => {
                      gestioneSnackbar(true, res.message, "success");
                      refreshContent();
                    })
                    .catch((err) =>
                      gestioneSnackbar(true, err.message, "error")
                    );
                }}
                style={{ color: "#000" }}
              >
                {admin
                  ? t("list_volunteers.option.make_volunteer")
                  : t("list_volunteers.option.make_admin")}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  e.preventDefault();
                  removeVolunteerWS({
                    id_user_association: id,
                    id_association: idAssociation,
                  })
                    .then((res) => {
                      gestioneSnackbar(true, res.message, "success");
                      refreshContent();
                    })
                    .catch((err) =>
                      gestioneSnackbar(true, err.message, "error")
                    );
                }}
                style={{ color: "#000" }}
              >
                {t("list_volunteers.option.remove_volunteer")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : (
        <div className="request-box">
          <BoxIcon
            icon={<ClearIcon />}
            color={"#CB1616"}
            callBack={rejectCallback}
          />
          <BoxIcon
            icon={<CheckIcon />}
            color={"#4190A3"}
            callBack={acceptCallback}
          />
        </div>
      )}
    </div>
  );
};

const BoxIcon = ({ icon, color, callBack }) => {
  return (
    <div className="box-icon" style={{ color }} onClick={callBack}>
      {icon}
    </div>
  );
};

export default VolunteerInfoBox;
